import React from 'react';
import { AboutDescription, AboutDescriptionProps } from 'screens/AgentOfficePages/common/sections/about/Description';
import { Card } from 'screens/AgentOfficePages/common/components/AgentCard';
import * as Styled from './styled';
import { StaticContactForm } from '../contact/static';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { Social } from '../../components/Social';
import { useLocale } from 'locale';
import { IAgentAbout } from 'screens/AgentOfficePages/types';


export const About: React.FC<IAgentAbout> = ({
  agentId,
  name,
  title,
  licenseId,
  licenseFromYear,
  description,
  logo,
  officeLogo,
  officeName,
  officeId,
  phone,
  pageDetails,
  isLeadingAgent,
}) => {
  const { t } = useLocale();
  const isMobile = useScreenBreakpoint() === 1;

  const descroptionProps: AboutDescriptionProps = {
    title: name,
    description,
    subtitle: licenseFromYear && licenseId ? t('newAgent.license.info', { year: licenseFromYear, license: licenseId }) : null,
    isLeading: isLeadingAgent,
    officeName: officeName || name,
    officeLogoUrl: officeLogo,
    officeId,
  };

  if (!description && isMobile) return null;

  return (
    <Styled.AboutWrapperSection>
      <Styled.DescrWrapper>
        <ShowAt from={2}>
          <Styled.AgentCardWrapper>
            <Card
              agentId={agentId}
              isLeading={isLeadingAgent}
              iconUrl={logo}
              withOfficeLogo
              fullSizeOn
              size="small"
            />
          </Styled.AgentCardWrapper>
        </ShowAt>
        <Styled.InfoWrapper>
          <AboutDescription {...descroptionProps} />
        </Styled.InfoWrapper>
        <ShowAt from={2}>
          <Styled.SocialWrapper>
            <Social name={officeName ? t('officePage.defaultTitle') : title} source="header" pageDetails={pageDetails} />
          </Styled.SocialWrapper>
        </ShowAt>
      </Styled.DescrWrapper>
      <ShowAt from={3}>
        <StaticContactForm phone={phone} isLeadingAgent={isLeadingAgent} formOnly noShadow isAgent id={agentId} />
      </ShowAt>
    </Styled.AboutWrapperSection>
  );
};
